// the library of inputs that we can use in our CustomFormCompInput


// use base class with inheritance -- later
  
import PrimeInputText from 'primevue/inputtext';
//import PrimeInputMask from 'primevue/inputmask';
import PrimeTextarea from 'primevue/textarea';
import PrimeCalendar from 'primevue/calendar';

import { DateTime } from 'luxon';


// the parser/formatter functions should take these args: (value, evalContext)
// no group type in here.... handle that separately

const inputDefs = [
    {
        key: 'text',
        inputComponent: PrimeInputText,  // likely have to register this component in the component where used?
        inputEventName: 'input',  // name of event on the input component that we should wire up to input handler
        blurEventName: 'blur',  // name of event on the input component that we should wire up to blur handler
        inputDefaultProps: {},  // optional, if used, object of default props to pass to inputComponent, but CAN BE OVERRIDDEN IN SCHEMA
        inputFixedProps: {},  // optional, if used, object of FIXED props to pass to inputComponent, CANNOT be overridden
        inputClass: [],  // added to inputComponent?
        // these are optional methods... if not used, then we pass things straight through
        toComponentValue: (val) => String(val),  // parse from external/intial form data TO the inputComponent value
        fromComponentValue: (val) => String(val),  // parse from the value in component @input event to the form value
        // DISPLAY MODE STUFF
        displayComponent: PrimeInputText,  // if blank, uses same as inputComponent?  to not show anything, set false?
        displayDefaultProps: {},
        displayFixedProps: {},
        displayClass: [],  // added to displayComponent?
        toDisplayValue: (val) => String(val),  // return a string? component? template? to show in displayMode
    },
    {
        key: 'email',
        inputComponent: PrimeInputText,  // likely have to register this component in the component where used?
        inputEventName: 'input',  // name of event on the input component that we should wire up to input handler
        blurEventName: 'blur',  // name of event on the input component that we should wire up to blur handler
        inputDefaultProps: {},  // optional, if used, object of default props to pass to inputComponent, but CAN BE OVERRIDDEN IN SCHEMA
        inputFixedProps: {
            type: 'email',
        },  // optional, if used, object of FIXED props to pass to inputComponent, CANNOT be overridden
        inputClass: [],  // added to inputComponent?
        // these are optional methods... if not used, then we pass things straight through
        toComponentValue: (val) => String(val),  // parse from external/intial form data TO the inputComponent value
        fromComponentValue: (val) => String(val),  // parse from the value in component @input event to the form value
        // DISPLAY MODE STUFF
        displayComponent: PrimeInputText,  // if blank, uses same as inputComponent?  to not show anything, set false?
        displayDefaultProps: {},
        displayFixedProps: {
            type: 'email',
        },
        displayClass: [],  // added to displayComponent?
        toDisplayValue: (val) => String(val),  // return a string? component? template? to show in displayMode
    },
    {
        key: 'textarea',
        inputComponent: PrimeTextarea,  // likely have to register this component in the component where used?
        inputEventName: 'input',  // name of event on the input component that we should wire up to input handler
        blurEventName: 'blur',  // name of event on the input component that we should wire up to blur handler
        inputDefaultProps: {},  // optional, if used, object of default props to pass to inputComponent, but CAN BE OVERRIDDEN IN SCHEMA
        inputFixedProps: {},  // optional, if used, object of FIXED props to pass to inputComponent, CANNOT be overridden
        inputClass: [],  // added to inputComponent?
        // these are optional methods... if not used, then we pass things straight through
        toComponentValue: null,  // parse from external/intial form data TO the inputComponent value
        fromComponentValue: null,  // parse from the value in component @input event to the form value
        // DISPLAY MODE STUFF
        displayComponent: null,  // if blank, uses same as inputComponent?  to not show anything, set false?
        displayDefaultProps: {},
        displayFixedProps: {},
        displayClass: [],  // added to displayComponent?
        toDisplayValue: null,  // return a string? component? template? to show in displayMode
    },
    {
        key: 'date',
        inputComponent: PrimeCalendar,  // likely have to register this component in the component where used?
        inputEventName: 'input',  // name of event on the input component that we should wire up to input handler
        blurEventName: 'blur',  // name of event on the input component that we should wire up to blur handler
        inputDefaultProps: {
            dateFormat: 'M d, yy',
            showIcon: true,
            icon: 'pi pi-calendar',
        },  // optional, if used, object of default props to pass to inputComponent, but CAN BE OVERRIDDEN IN SCHEMA
        inputFixedProps: {
            selectionMode: 'single',
            view: 'date',
            showTime: false,
            manualInput: false,
        },  // optional, if used, object of FIXED props to pass to inputComponent, CANNOT be overridden
        inputClass: ['w-100'],  // added to inputComponent?
        // these are optional methods... if not used, then we pass things straight through
        toComponentValue: (val) => {
            // our value should be ISO date string (YYYY-MM-DD) but PrimeCalendar takes JS Date
            if (!val) {
                return null;
            } else if (typeof val === 'string') {
                const luxonDT = DateTime.fromISO(val);  // will parse to a full DateTime, with time things set to minimum values
                return luxonDT.toJSDate();  // should work....
            } else if (DateTime.isDateTime(val)) {
                return val.toJSDate();
            } else if (val instanceof Date) {
                return val;
            } else {
                return null; 
            }
        },  // parse from external/intial form data TO the inputComponent value
        fromComponentValue: (val) => {
            // PrimeCalendar will pass up a JS Date object (TZ aware, likely with TZ set to user local time)
            // we need to convert to YYYY-MM-DD string
            if (!val) {
                return null;  // or ''?
            } else if (val instanceof Date) {  // should be....
                const luxonDT = DateTime.fromJSDate(val);
                return luxonDT.toISODate();
            } else if (DateTime.isDateTime(val)) {
                return val.toISODate();
            } else {
                return null; 
            }
        },  // parse from the value in component @input event to the form value
        // DISPLAY MODE STUFF
        displayComponent: PrimeCalendar,  // if blank, uses same as inputComponent?  to not show anything, set false??? make sure all your logic around that works...
        displayDefaultProps: {
            dateFormat: 'M d, yy',
            showIcon: false,
            icon: 'pi pi-calendar',
        },
        displayFixedProps: {
            selectionMode: 'single',
            view: 'date',
            showTime: false,
            manualInput: false,
        },
        displayClass: null,  // added to displayComponent?  if null, use ones from inputClass?  or only if we use everything from input for display???
        toDisplayValue: null,  // TODO - return a string? component? template? to show in displayMode
    },
]

const inputDefsByKey = Object.fromEntries(inputDefs.map(c => [c.key, c]));

export {
    inputDefs,
    inputDefsByKey,
}
